import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchSite } from '../actions/sites';
import { getSiteByKey } from '../selectors/sites';
import { fetchPage } from '../actions/page';

const Page = loadable(() => import(/* webpackChunkName: "connect" */ '../containers/Page'), {
  fallback: Loading
});

Page.needs = async (props, { getState, dispatch }) => {
  await dispatch(fetchSite(props.params.site));
  const site = getSiteByKey(getState(), props.params.site);
  if (!site || !site.pages || !props.params.id) return;
  const page = site.pages.find(p => p.entity_key === props.params.id);
  return page && dispatch(fetchPage(page.id));
};

export default Page;
